let transitionName = null;
export const transitionEnd = () => {
  if (transitionName !== null) {
    return transitionName;
  }

  const el = document.createElement('div'); // what the hack is bootstrap

  const transEndEventNames = {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd',
  };

  /* eslint-disable no-restricted-syntax */
  for (const name in transEndEventNames) {
    if (el.style[name] !== undefined) {
      transitionName = transEndEventNames[name];
      return transitionName;
    }
  }
  /* eslint-enable no-restricted-syntax */

  transitionName = false;
  return transitionName;
};

let animationName = null;
export const animationEnd = () => {
  if (animationName !== null) {
    return animationName;
  }

  const el = document.createElement('div'); // what the hack is bootstrap

  const animEndEventNames = {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd',
  };

  /* eslint-disable no-restricted-syntax */
  for (const name in animEndEventNames) {
    if (el.style[name] !== undefined) {
      animationName = animEndEventNames[name];
      return animationName;
    }
  }
  /* eslint-enable no-restricted-syntax */

  animationName = false;
  return animationName;
};

export const getOffsetTop = (element) => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
};

/* eslint-disable no-restricted-syntax, no-prototype-builtins */
export const toQueryString = (obj, showEmptyValue = false) => {
  const parts = [];
  for (const i in obj) {
    if (obj.hasOwnProperty(i)) {
      const value = obj[i] ? encodeURIComponent(obj[i]) : '';
      if (value || showEmptyValue) {
        parts.push(`${i}=${value}`);
      }
    }
  }
  return parts.join('&');
};
/* eslint-enable no-restricted-syntax, no-prototype-builtins */

export const getQueryParams = (queryString) => {
  const query = {};
  const pairs = (
    queryString[0] === '?' ? queryString.substr(1) : queryString
  ).split('&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
};

export const toQueryCartString = (list) => {
  const query = [];
  list.forEach((item) => {
    query.push(`${item.id}-${item.count}`);
  });

  return query.join('_');
};

export const getQueryCartParams = (query) => {
  if (!query) return null;

  return query.split('_').map((item) => {
    const split = item.split('-');
    return { id: split[0], count: parseInt(split[1], 10) || 0 };
  });
};

let isMobileMode = null;
export const isMobile = () => {
  if (isMobileMode === null) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    isMobileMode =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/.test(
        userAgent,
      );
  }
  return isMobileMode;
};

export const isIos = () => {
  return !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
};

export const isAndroid = () => {
  return !!navigator.userAgent.match(/(Android)/g);
};

export const redirectToBank = (data) => {
  if (data) {
    if (data.token) {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('name', data.tokenName);
      hiddenField.setAttribute('value', data.token);
      const formRaw = document.createElement('form');
      formRaw.setAttribute('method', 'POST');
      formRaw.setAttribute('action', data.link);
      formRaw.setAttribute('target', '_self');
      formRaw.appendChild(hiddenField);
      document.body.appendChild(formRaw);
      formRaw.submit();
      document.body.removeChild(formRaw);
    } else {
      window.location.replace(data.link);
    }
  }
};
